export default __webpack_public_path__ + "static/media/InnovEdu Logo Final.33c4c2e9.png";